import { useEffect } from 'react';
import { RouterProvider } from 'react-router';
import { router } from './config';
import { initRouteTracking } from '@/lib/analytics';

export function AppRouter() {
    // Subscribe at the router level rather than inside a layout: every route in
    // this app is reported, including the public consent/reference pages that
    // don't share a layout with the authenticated tree.
    useEffect(() => initRouteTracking(router), []);

    return <RouterProvider router={router} />;
}

export default AppRouter;
